import apiClient from './mobileAuthService'

/**
 * モバイルお問い合わせサービス
 * お問い合わせ送信、ユーザー情報取得などのお問い合わせ関連機能を提供
 */
export const mobileInquiryService = {
  /**
   * お問い合わせ送信
   * ユーザーからのお問い合わせ内容をサーバーに送信
   * @param {Object} inquiryData - お問い合わせデータ
   * @param {string} inquiryData.name - ユーザー名
   * @param {string} inquiryData.mail - メールアドレス
   * @param {string} inquiryData.subject - 件名
   * @param {string} inquiryData.content - 内容
   * @returns {Promise<Object>} 送信結果
   */
  async sendInquiry(inquiryData) {
    const response = await apiClient.post('/sendInquiry', {
      name: inquiryData.name,
      userMailAddress: inquiryData.mail,
      subject: inquiryData.subject,
      content: inquiryData.content,
    })
    
    return response.data
  },

  /**
   * ユーザー情報取得（お問い合わせ画面初期化用）
   * お問い合わせ画面の初期化に必要なユーザー情報を取得
   * @returns {Promise<Object>} ユーザー情報
   */
  async getUserInfo() {
    const response = await apiClient.post('/appInquiry', {})
    return response.data
  },
}

export default mobileInquiryService
